// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__P5Pvv","validationTips":"StatementDescriptor_validationTips__2rZio"};